import { Link } from "react-router-dom";
import { SIGNIN_URL, SIGNUP_URL } from "../constants";

export function Header() {
  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-background/80 backdrop-blur">
      <div className="container mx-auto flex h-14 items-center justify-between px-4">
        <Link to="/" className="text-lg font-semibold tracking-tight">
          Tapelens
        </Link>
        <nav className="flex items-center gap-2 text-sm">
          <Link
            to="/pricing"
            className="px-3 py-1.5 text-muted-foreground hover:text-foreground"
          >
            Pricing
          </Link>
          <a
            href={SIGNIN_URL}
            className="px-3 py-1.5 text-muted-foreground hover:text-foreground"
          >
            Sign in
          </a>
          <a
            href={SIGNUP_URL}
            className="rounded-md bg-primary px-3 py-1.5 font-medium text-primary-foreground hover:opacity-90"
          >
            Start free trial
          </a>
        </nav>
      </div>
    </header>
  );
}
